import { Link } from "react-router-dom";
import { Play, Plus, Info, Star } from "lucide-react";
import { resolveUrl } from "../lib/url";

export default function HeroBanner({ item }) {
  if (!item) return <div className="h-[60vh] bg-[#0a0a0a]" />;
  const isSeries = !!item.totalSeasons;
  const path = `/${isSeries ? "series" : "movie"}/${item.id}`;
  const banner = resolveUrl(item.bannerUrl);

  return (
    <div className="relative h-[80vh] min-h-[560px] w-full overflow-hidden" data-testid="hero-banner">
      <div className="absolute inset-0">
        {banner ? (
          <img
            src={banner}
            alt={item.title}
            className="w-full h-full object-cover"
          />
        ) : (
          <div className="w-full h-full bg-gradient-to-br from-[#1a0303] via-[#0a0a0a] to-[#0a0a0a]" />
        )}
        <div className="absolute inset-0 hero-gradient" />
      </div>

      <div className="absolute inset-0 flex flex-col justify-end px-4 sm:px-12 pb-24 max-w-3xl animate-fade-up">
        <div className="flex items-center gap-3 mb-3">
          <span className="text-xs font-bold text-[#E50914] uppercase tracking-[0.2em]">
            {isSeries ? "Original Series" : "Featured Film"}
          </span>
        </div>
        <h1 className="text-4xl sm:text-6xl lg:text-7xl font-black text-white tracking-tighter mb-4" style={{ fontFamily: "Outfit", textShadow: "0 4px 20px rgba(0,0,0,0.8)" }}>
          {item.title}
        </h1>
        <div className="flex items-center gap-3 text-sm text-[#ddd] mb-4 flex-wrap">
          {item.rating ? (
            <span className="flex items-center gap-1"><Star size={14} className="fill-yellow-400 text-yellow-400" />{item.rating.toFixed(1)}</span>
          ) : null}
          {item.releaseYear && <span>{item.releaseYear}</span>}
          {item.duration && <span>{item.duration}</span>}
          {item.genre && item.genre.length > 0 && (
            <span className="px-2 py-0.5 border border-white/30 rounded text-xs uppercase tracking-wider">
              {item.genre[0]}
            </span>
          )}
        </div>
        <p className="text-base sm:text-lg text-[#ddd] leading-relaxed mb-6 line-clamp-3 max-w-xl">
          {item.description}
        </p>
        <div className="flex items-center gap-3 flex-wrap">
          <Link to={`/watch/${isSeries ? "series" : "movie"}/${item.id}`} className="btn-primary" data-testid="hero-play-btn">
            <Play size={18} className="fill-white" /> Play
          </Link>
          <Link to={path} className="btn-secondary" data-testid="hero-more-info-btn">
            <Info size={18} /> More Info
          </Link>
          <button className="btn-secondary !px-3" data-testid="hero-add-list-btn" aria-label="Add to my list">
            <Plus size={18} />
          </button>
        </div>
      </div>
    </div>
  );
}
